import Vue from 'vue';
import axios from 'axios';
import '@/assets/css/main.css';
import '@/assets/css/quil.core.css';
import "@/assets/css/fonts.css";
import store from "./store/index";
import router from "./router/index";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import App from "./App.vue";
import {
  getLocalizedText,
  getAllergenName,
  getTranslatedText,
} from "./helpers/localization";
import { getProductImageUrl } from "./helpers/productImage";
// TEMPORARY: on-screen error overlay for iPhone debugging (VUE_APP_DEBUG_ERRORS=true)
import { installErrorOverlay } from "./debug/errorOverlay";

// Registered first so it can catch failures during the rest of bootstrap.
installErrorOverlay(Vue);

Vue.use(require("vue-moment"));
Vue.prototype.$http = axios;

// Settings text from POSHUB may be a plain string or a { nl, en } object.
// $lt() renders either shape using the active vue-i18n locale.
Vue.prototype.$lt = function $lt(value) {
  const locale = this && this.$i18n ? this.$i18n.locale : i18n.locale;
  return getLocalizedText(value, locale);
};

// Catalogue text (product, category, optional group, option product) arrives
// as a base field plus a `*_translations` map. $pt() renders the map for the
// active locale, or the base text when there is no map. The locale is read on
// every call, inside the render, so switching it re-renders in place.
Vue.prototype.$pt = function $pt(translations, base) {
  const locale = this && this.$i18n ? this.$i18n.locale : i18n.locale;
  return getTranslatedText(translations, base, locale);
};

// Allergens carry translations in `data`; falls back to the English `name`.
Vue.prototype.$allergenName = function $allergenName(allergen) {
  const locale = this && this.$i18n ? this.$i18n.locale : i18n.locale;
  return getAllergenName(allergen, locale);
};

// Products may carry a WebP derivative (image_webp, absolute) alongside the
// original (image, relative). $productImage() prefers the smaller WebP.
Vue.prototype.$productImage = function $productImage(product) {
  return getProductImageUrl(product);
};
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
  created() {},
}).$mount("#app");
